import * as React from 'react';

import { Button, Row, cn } from '@rematter/ui-web';

export interface FormFooterProps {
  onDiscard?: () => void;
  onSave?: () => void;
  isDiscardDisabled?: boolean;
  isSaveDisabled?: boolean;
  isSaveLoading?: boolean;
  discardLabel?: string;
  saveLabel?: string;
  className?: string;
}

export const FormFooter: React.FC<FormFooterProps> = ({
  onDiscard,
  onSave,
  isDiscardDisabled = false,
  isSaveDisabled = false,
  isSaveLoading = false,
  discardLabel = 'Discard',
  saveLabel = 'Save updates',
  className,
}) => (
  <div
    className={cn(
      '@FormFooter border-t border-neutral/15 px-5 py-4',
      className,
    )}
  >
    <Row xEnd gap2>
      <Button
        variant="outline"
        onPress={onDiscard}
        isDisabled={isDiscardDisabled}
      >
        {discardLabel}
      </Button>
      <Button
        variant="solid"
        color="primary"
        onPress={onSave}
        isDisabled={isSaveDisabled}
        isLoading={isSaveLoading}
      >
        {saveLabel}
      </Button>
    </Row>
  </div>
);
